import { AddressViewModel } from '../../models/Entities/Person/Address/AddressModels';
import { CommonState } from '../common/state/commonState';

export interface PersonAddressState extends CommonState<AddressViewModel> {
    lastCreated?: AddressViewModel;
}

export const PersonAddressUnloadState: PersonAddressState = {
    isLoadingAll: false,
    successLoadingAll: undefined,
    failOnLoadingAll: false,

    isLoadingOne: false,
    successLoadingOne: undefined,
    failOnLoadingOne: false,

    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,

    isDeletingOne: false,
    successDeletingOne: undefined,
    failOnDeletingOne: false,

    list: [],
    error: undefined,
    lastCreated: undefined
};
